import React, { Suspense } from "react";
import { Routers } from "./routes";

export const App = () => {
  return (
      <Suspense fallback={'Conectando la app...'}>
        <Routers />
      </Suspense>
  );
};
